import React, { useState } from 'react';

interface Props {
  title: string;
  defaultValue: string;
  httpsOnly: boolean;
}

const JsonLayer: React.FC<Props> = ({ title = 'JSON', defaultValue = '', httpsOnly = false }: Props) => {
  const [value, setValue] = useState(defaultValue || '');

  return (
    <div className="layer-type-form">
      <div className="layer-source clearfix">
        <label htmlFor="layer_source" className="required">{title}</label>
        <div className="input">
          <textarea
            name="layer[source]"
            id="layer_source"
            className="span6"
            rows={10}
            value={value}
            onChange={(e) => setValue(e.target.value)}
          />
          {
            httpsOnly
            && (
              <div className="helper">
                <b>Please note:</b>
                {' '}
                URLs must use
                {' '}
                <b>https</b>
              </div>
            )
          }
        </div>
      </div>
    </div>
  );
};

export default JsonLayer;
